<!--
 * @Description: 谷仓-商机
 * @Author: mdb
 * @Date: 2022-06-30 20:51:19
 * @LastEditTime: 2023-04-10 16:25:50
 * @LastEditors: mdb
-->
<template>
  <dc-layout-main :is-breadcrumb="true">
    <dc-layout-content>
      <a-tabs v-model:activeKey="queryForm.dataType" @change="handleTabsChange">
        <a-tab-pane key="all" tab="全部" />
        <a-tab-pane key="me" tab="我的商机" />
        <a-tab-pane key="subUser" tab="下属商机" />
      </a-tabs>
      <cos-table
        serial
        :columns="columns"
        v-model:search="queryForm"
        @fetch="getList"
        @mask="showMask"
        ref="tableRef"
        rowKey="id"
        tableId="DcCosFbuBusiness"
      >
        <template #search>
          <a-form :model="queryForm">
            <dc-form-item name="status" label="商机状态">
              <a-select
                v-model:value="queryForm.statusList"
                :options="businessStatusEnum"
                placeholder="请选择商机状态"
                allowClear
                mode="multiple"
              />
            </dc-form-item>
            <dc-form-item name="customerName" label="客户名称">
              <a-input
                v-model:value.trim="queryForm.customerName"
                :maxlength="100"
                allowClear
                placeholder="请输入客户名称"
              />
            </dc-form-item>
            <dc-form-item label="子客户代码">
              <a-input v-model:value="queryForm.arkCode" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item name="dutyBy" label="客户负责人" v-if="queryForm.dataType !== 'me'">
              <UserSelect v-model:value="queryForm.dutyBy" placeholder="请选择客户负责人" allowClear />
            </dc-form-item>
            <dc-form-item name="orderType" label="订单类型">
              <a-select
                v-model:value="queryForm.orderType"
                :options="orderTypeEnum"
                placeholder="请选择订单类型"
                allowClear
              />
            </dc-form-item>
            <dc-form-item name="chanceType" label="商机类型">
              <ParamCodesSelect
                v-model:value="queryForm.chanceType"
                :options="paramCodeData.fbu_chance_type"
                placeholder="请选择商机类型"
                allowClear
              />
            </dc-form-item>
            <dc-form-item name="tailWarehouse" label="尾程仓库名称">
              <ParamCodesSelect
                v-model:value="queryForm.tailWarehouse"
                :options="paramCodeData.fbu_tail_warehouse_name"
                placeholder="请选择尾程仓库名称"
                allowClear
              />
            </dc-form-item>
            <dc-form-item name="timeOut" label="是否超时">
              <a-select
                v-model:value="queryForm.changeTimeoutFlag"
                :options="chanceTimoutFilterEnum"
                placeholder="请选择是否超时"
                allowClear
              />
            </dc-form-item>
            <dc-form-item name="timeType" label="时间查询">
              <a-input-group compact>
                <a-select v-model:value="queryForm.timeType" :options="timeTypeEnum" style="width: 33%" />
                <CosRangePicker
                  v-model:startTime="queryForm.startTime"
                  v-model:endTime="queryForm.endTime"
                  style="width: 67%"
                />
              </a-input-group>
            </dc-form-item>
            <dc-form-item name="tailWarehouse" label="国内仓库">
              <ParamCodesSelect
                v-model:value="queryForm.headDomesticWarehouse"
                :options="paramCodeData.fbu_head_domestic_warehouse"
                placeholder="请选择国内仓库"
                allowClear
              />
            </dc-form-item>
            <dc-form-item name="tailWarehouse" label="目的国仓库">
              <ParamCodesSelect
                v-model:value="queryForm.headDestinationCountryWarehouse"
                :options="paramCodeData.fbu_head_destination_country_warehouse"
                placeholder="请选择目的国仓库"
                allowClear
              />
            </dc-form-item>
            <dc-form-item name="tailWarehouse" label="运输方式">
              <ParamCodesSelect
                v-model:value="queryForm.headTransportMode"
                :options="paramCodeData.fbu_head_replenish_method"
                placeholder="请选择运输方式"
                allowClear
              />
            </dc-form-item>
            <dc-form-item name="sourceChannelList" label="来源渠道">
              <ParamCodeCascader
                v-model:ids="queryForm.sourceChannelList"
                type="search"
                appId="cos_fbu"
                paramCode="fbu_source_channel"
                placeholder="请选择来源渠道"
                allowClear
              />
            </dc-form-item>
            <dc-form-item name="saleChanceRefId" label="客户ID">
              <a-input
                v-model:value.trim="queryForm.saleChanceRefId"
                :maxlength="500"
                allowClear
                placeholder="请输入客户ID"
              />
            </dc-form-item>
            <dc-form-item name="id" label="商机ID">
              <a-input v-model:value="queryForm.id" :maxlength="500" allowClear placeholder="请输入商机ID" />
            </dc-form-item>
          </a-form>
        </template>

        <template #button>
          <a-button v-permission="'fbu_business_add_btn'" type="primary" @click="triggerAddOrEdit()">新增</a-button>
          <ExportButton v-permission="'fbu_business_export_btn'" appId="cos_fbu" taskType="207" :search="handleQueryParams(queryForm)"
            >导出</ExportButton
          >
        </template>

        <template #bodyCell="{ column, record, text,index }">
          <template v-if="column.dataIndex === 'saleChanceName'">
            <div class="flex">
              <a-tooltip placement="topLeft" color="rgba(19, 32, 67, 0.9)">
                <template #title>
                  <div>
                    当前时间超过预计达成时间未达成合作或完结
                  </div>
                </template>
                <p class="time-out-flag"  v-if="record.changeTimeoutFlag === true">超时</p>
              </a-tooltip>
              <router-link :to="'/fbu/business/view?id=' + record.id">
                <template v-if="text">
                  <BusinessName
                    appId="cos_fbu"
                    v-model:value="record.saleChanceName"
                    v-model:label="record.saleChanceNameByTxt"
                  />
                </template>
                <template v-else>--</template>
              </router-link>
            </div>
          </template>
          <template v-if="column.dataIndex === 'customerName'">
            <router-link
              :to="getCustomLink(record)"
              class="ant-table-cell-ellipsis"
              :title="text"
            >{{ text || '--' }}</router-link>
          </template>
          <template v-if="column.dataIndex === 'status'">
            <dc-status :enums="statusEnum" :value="text" />
          </template>
          <template v-if="column.dataIndex === 'orderType'">
            {{ orderTypeEnum?.find((e) => e.value === text)?.label || text || '--' }}
          </template>
          <template v-if="column.dataIndex === 'chanceType'">
            {{ paramCodeData.fbu_chance_type?.find((e) => e.id === text)?.name || text }}
          </template>
          <template v-if="column.dataIndex === 'headCompetitors' || column.dataIndex === 'tailCompetitors'">
            {{ competitorFormat(record.orderType, text) || '--' }}
          </template>
          <template v-if="column.dataIndex === 'action'">
            <a-button
              v-permission="'fbu_business_write_follow_btn'"
              type="link"
              @click="handleWriteFollowUp(record.saleChanceRefId, record.id)"
              >写跟进</a-button
            >
            <SellerButton
              v-permission="'fbu_business_edit_btn'"
              type="link"
              :workCode="record.dutyBy"
              :disabled="record.status>6"
              @click="triggerAddOrEdit(record.id)"
              >编辑</SellerButton
            >
            <a-button
              type="link"
              :disabled="record.chanceType != 399"
              @click="copyChance(record.id)"
            >复制</a-button
            >
            <SellerButton
              v-permission="'fbu_chance_close_btn'"
              type="link"
              :disabled="record.status >= 7"
              @click="handleManagerCloseChance(index,record)"
            >关闭
            </SellerButton
            >
            <a-button v-permission="'fbu_business_del_btn'" type="link" @click="handleDelete(record)">删除</a-button>
          </template>
        </template>
      </cos-table>
    </dc-layout-content>
  </dc-layout-main>
</template>

<script setup lang="ts">
import { reactive, computed, ref, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { DcConfirm, message } from '@dc-platform/dc-components'
import BusinessName from '@/components/BusinessName/index.vue'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import Modal from '@/hooks/modalType'
import { listByParamCodes } from '@/api/common'
import { businessStatusEnum, chanceTimoutFilterEnum, orderTypeEnum } from '@/views/gucangSales/commonEnum/dataConfig'
import type { ParamCodeItem } from '@/typings/common'
import { businessList, businessDelete, businessDetails, businessChangeStatus } from '@/api/gucangSales/chanceManage'
import { BusinessParams, BusinessListItem } from '@/typings/api/chanceManage'
import FavoriteIcon from '@/components/FavoriteIcon/index.vue'
import { cloneDeep } from 'lodash-es'
import { LbuSalesClueParams } from '@/typings/api/clueManage'
import { customerListFormat } from '@/utils'
const router = useRouter()
const route = useRoute()

const statusEnum = businessStatusEnum.map((item) => ({
  name: item.label,
  value: item.value,
  color: item.color
}))
// 时间类型枚举
const timeTypeEnum = [
  { label: '创建时间', value: 0 },
  { label: '跟进时间', value: 1 }
]
const paramCodeData = ref<{
  fbu_tail_warehouse_name: ParamCodeItem[]
  fbu_chance_type: ParamCodeItem[]
  fbu_head_competitors: ParamCodeItem[]
  fbu_warehouse: ParamCodeItem[]
  fbu_head_domestic_warehouse: ParamCodeItem[]
  fbu_head_destination_country_warehouse: ParamCodeItem[]
  fbu_head_replenish_method: ParamCodeItem[]
}>({
  fbu_tail_warehouse_name: [], // 尾程仓库名称
  fbu_chance_type: [], // 商机类型
  fbu_head_competitors: [], // 头程竞争对手
  fbu_warehouse: [], // 尾程竞争对手（目前合作海外仓）
  fbu_head_domestic_warehouse: [], // 国内仓库
  fbu_head_destination_country_warehouse: [], // 目的国仓库
  fbu_head_replenish_method: [] // 运输方式
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_fbu',
    paramCodes: [
      'fbu_tail_warehouse_name',
      'fbu_chance_type',
      'fbu_head_competitors',
      'fbu_warehouse',
      'fbu_head_domestic_warehouse',
      'fbu_head_destination_country_warehouse',
      'fbu_head_replenish_method'
    ]
  }).then((res) => {
    paramCodeData.value = res.data
  })
}
onMounted(() => getByParamCodes())
const tableRef = ref()
const queryForm = reactive<BusinessParams>({ dataType: 'all', timeType: 0 })
const columns = computed(() => [
  { title: '商机名称', dataIndex: 'saleChanceName', fixed: 'left', width: 190 },
  { title: '客户名称', dataIndex: 'customerName', width: 200 },
  { title: '子客户代码', dataIndex: 'arkCode' },
  { title: '客户ID', dataIndex: 'saleChanceRefId', width: 200 },
  { title: '商机ID', dataIndex: 'id', width: 200 },
  { title: '主客户代码', dataIndex: 'customerNumber' },
  { title: '商机类型', dataIndex: 'chanceType' },
  { title: '联系人姓名', dataIndex: 'contactName', cosType: 'mask' },
  { title: '手机号', dataIndex: 'contactMobile', cosType: 'mask' },
  { title: '订单类型', dataIndex: 'orderType' },
  { title: '预计月销售额(万)', dataIndex: 'planSaleAmount' },
  { title: '商机状态', dataIndex: 'status' },
  { title: '尾程竞争对手', dataIndex: 'tailCompetitors' },
  { title: '头程竞争对手', dataIndex: 'headCompetitors' },
  { title: '客户负责人', dataIndex: 'dutyByName' },
  { title: '备注', dataIndex: 'remark' },
  { title: '创建人', dataIndex: 'createByName' },
  { title: '创建时间', dataIndex: 'createTime', width: 190 },
  { title: '达成时间', dataIndex: 'reachTime', width: 190 },
  { title: '完结时间', dataIndex: 'overTime', width: 190 },
  { title: '操作', dataIndex: 'action', width: 180, fixed: 'right' }
])
const handleQueryParams = (queryForm: BusinessParams) => {
  const params = cloneDeep(queryForm)
  const chanceIds = params.id?.toString().split(/[,，\s\n]/).filter((e: string) => e)
  if (chanceIds && chanceIds.length > 1) {
    params.idList = chanceIds
    delete params.id
  }
  return params
}
const getCustomLink = (row:any) => {
  if (row && row.customerStage === 2) {
    return `/fbu/potential/view?cosId=${row.saleChanceRefId}`
  }
  if (row && row.customerStage === 3) {
    return `/fbu/contract/view?cosId=${row.saleChanceRefId}`
  }
  if (row && row.customerStage === 4) {
    return `/fbu/clients/view?cosId=${row.saleChanceRefId}`
  }
  return ''
}
const getList = (queryForm: BusinessParams, callBack: (res: any) => void) => {
  const params = handleQueryParams(queryForm)
  businessList(params).then((res) => {
    callBack(res)
  })
}
const showMask = (record: BusinessListItem, callBack: (res: any) => void) => {
  businessDetails({ id: record.id }).then((res) => {
    callBack(res.data)
  })
}
const handleTabsChange = (val: any) => {
  queryForm.dataType = val
  if (val === 'me' && queryForm.dutyBy) {
    queryForm.dutyBy = undefined
  }
  tableRef.value?.search()
}
// 新增编辑函数
const triggerAddOrEdit = (id?: number) => {
  if (id) {
    router.push({ path: '/fbu/business/edit', query: { id } })
  } else {
    router.push('/fbu/business/add')
  }
}
// 新增编辑函数
const copyChance = (id?: number) => {
  router.push({ path: '/fbu/business/copy', query: { id } })
}
const handleManagerCloseChance = (index: number, row: BusinessListItem) => {
  DcConfirm.warning({
    title: '操作提示！',
    content: '是否确认此操作？',
    cancelText: '取消',
    okText: '继续',
    onOk() {
      if (!row.id) {
        return
      }
      const params = {
        id: row.id.toString(),
        status: 8
      }
      businessChangeStatus(params)
        .then(async () => {
          message.success('商机关闭成功')
          row.status = 8
          tableRef.value?.notifyItem(index, row)
        })
    }
  })
}
const handleDelete = (row: BusinessListItem) => {
  Modal.delete({
    name: row.saleChanceNameByTxt,
    onOk() {
      businessDelete({ id: row.id }).then(() => {
        message.success('删除商机成功')
        tableRef.value?.delFetch()
      })
    }
  })
}
// 跳转写跟进页面
const handleWriteFollowUp = (cosId: string, chanceId: string) => {
  router.push({
    path: '/fbu/followUpRecord/add',
    query: { followRefId: cosId, chanceId, returnPath: route.fullPath }
  })
}
/**
 * 竞争对手序列化
 * @param orderType 订单类型
 * @param arr 对手数组
 */
const competitorFormat = (orderType: number, arr: any) => {
  if (!Array.isArray(arr) || !arr?.length) return '--'
  const hasOrderType = orderTypeEnum.find((e) => e.value === orderType)
  if (!hasOrderType) return arr
  const listEnum = orderType === 1 ? paramCodeData.value.fbu_head_competitors : paramCodeData.value.fbu_warehouse
  const result: string[] = []
  arr.forEach((ele) => {
    const item = listEnum.find((e) => e.id === ele)
    if (item) result.push(item.name as string)
  })
  return result.join('、')
}
</script>
<script lang="ts">
export default { name: 'DcCosFbuBusiness' }
</script>

<style lang="scss" scoped></style>
